import { User } from 'oidc-client-ts'
import { userManager } from './oidcConfig'

export const subscribeAuthEvents = (
	onUserChange: (user: User | null) => void
) => {
	userManager.events.addUserLoaded((user) => {
		console.log('🔑 User loaded:', user)
		onUserChange(user)
	})

	userManager.events.addUserUnloaded(() => {
		console.log('🚪 User unloaded')
		onUserChange(null)
	})

	userManager.events.addAccessTokenExpired(() => {
		console.log('⚠️ Access token expired')
		onUserChange(null)
	})

	userManager.events.addSilentRenewError((error) => {
		console.error('🔁 Silent renew error:', error)
	})

	userManager.events.addAccessTokenExpiring(() => {
		console.log('⏰ Token is expiring...')
	})
}
